import { render, staticRenderFns } from "./saleRecord.vue?vue&type=template&id=9bf0b8e4&scoped=true&"
import script from "./saleRecord.vue?vue&type=script&lang=ts&"
export * from "./saleRecord.vue?vue&type=script&lang=ts&"
import style0 from "./saleRecord.vue?vue&type=style&index=0&id=9bf0b8e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf0b8e4",
  null
  
)

export default component.exports